<template>
  <!-- 审批管理 -->
  <div
    class="basemaintain"
    style="min-height:100vh;background-color:#ffffff"
  >
    <el-radio-group
      v-model="activeName"
      style="margin:18px 0 20px 0"
    >
      <el-radio-button label="我发起">我发起</el-radio-button>
      <el-badge
        :value="spNum"
        :max="99"
        class="item"
      >
        <el-radio-button label="待我审批">待我审批</el-radio-button>
      </el-badge>
      <el-radio-button label="全部">全部</el-radio-button>
      <el-badge
        :value="tzNum"
        :max="99"
        class="item"
      >
        <el-radio-button label="通知我">通知我</el-radio-button>
      </el-badge>
    </el-radio-group>

    <el-button
      type="warning"
      plain
      style="float: right;margin-top:20px;margin-right:20px;"
      icon="el-icon-back"
      @click="$router.back(-1)"
    >返回</el-button>
    <keep-alive>
      <JyTableSP
        v-if="activeName == '待我审批'"
        :key="key"
        ref="DwspList"
        :type-options="typeOptions"
        :data-all="true"
        :other-params="otherParams"
        :is-all="false"
        @num-change="getSPnum"
        @check-event="row_see"
      />
      <JyTableFQ
        v-if="activeName == '我发起'"
        ref="WfqList"
        :key="key"
        :type-options="typeOptions"
        :other-params="otherParams"
        :data-all="true"
        @check-event="row_see"
      />
      <JyTableSP
        v-if="activeName == '全部'"
        :key="key"
        ref="QbList"
        :type-options="typeOptions"
        :other-params="otherParams"
        :data-all="true"
        :is-all="true"
        @check-event="row_see"
      />
      <JyTableTZ
        v-if="activeName == '通知我'"
        :key="key"
        ref="TzwList"
        :type-options="typeOptions"
        :other-params="otherParams"
        :data-all="true"
        @num-change="getTZnum"
        @check-event="row_see"
      />
    </keep-alive>

  </div>
</template>

<script>
import {
  portalurl,
  CountApprovalRecordPendind,
  getServiceList,
  countApprovalRecordNotifier
} from '@/api/main/main'

export default {
  name: 'Basemaintain',
  data () {
    return {
      key: 1,
      otherParams: {
        // 其它参数
      },
      typeOptions: [
        // 类型选择数据
      ],
      spNum: '',
      tzNum: '',
      menuid: '', // 左侧菜单的id
      activeName: '待我审批',
      user: {}
    }
  },
  watch: {
    activeName (value, oldvalue) {
      this.key += 1
      this.getTZnum() // 获取通知个数
      this.getSPnum() // 获取审批个数
    }
  },
  activated () {
    // 在组件被激活时执行的代码，可以调用需要执行的方法
    if (this.activeName === '待我审批') {
      this.$refs.DwspList.threeMonthChange()
      this.getSPnum() // 获取审批个数
    } else if (this.activeName === '通知我') {
      this.$refs.TzwList.threeMonthChange()
      this.getTZnum() // 获取通知个数
    } else if (this.activeName === '我发起') {
      this.$refs.WfqList.threeMonthChange()
    } else if (this.activeName === '全部') {
      this.$refs.QbList.threeMonthChange()
    }
  },
  deactivated () {
    // 在组件被缓存时执行的代码
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.gettypelist() // 获取审批类型
    this.getSPnum() // 获取审批个数
    this.getTZnum() // 获取通知个数
    document.title = '我的审批'
  },
  methods: {
    // 获取审批个数
    getSPnum () {
      CountApprovalRecordPendind().then(res => {
        if (res.status === 200) {
          if (res.data === 0) {
            this.spNum = ''
          } else {
            this.spNum = res.data
          }
        }
      })
    },
    // 获取通知个数
    getTZnum () {
      countApprovalRecordNotifier().then(res => {
        if (res.status === 200) {
          if (res.data.total === 0) {
            this.tzNum = ''
          } else {
            this.tzNum = res.data.total
          }
        }
      })
    },
    async gettypelist () {
      getServiceList().then(res => {
        if (res.status === 200) {
          for (var i = 0; i < res.data.length; i++) {
            var obj = {
              value: res.data[i].sId,
              name: res.data[i].sName
            }
            this.typeOptions.push(obj)
          }
        }
      })
    },
    row_see (row) {
      const par = {
        source: row.source,
        serviceId: row.sId
      }
      portalurl(par).then(res => {
        if (res.status === 200) {
          // var url = res.data.url.substring(7)
          history.pushState(null, '', '/' + '#/Approvainfo?businessId=' + row.businessId +
            '&sId=' + row.sId + '&source=' + row.source + '&approvalId=' + row.approvalId +
            '&accurateConditions=' + row.accurateConditions + '&businessType=' + row.businessType)
          // window.open(
          //   window.location.protocol +
          //   "//" +
          //   window.location.host + '/subapp' +
          //   res.data.urlWeb +
          //   '?businessId=' +
          //   row.businessId +
          //   '&sId=' +
          //   row.sId +
          //   '&source=' +
          //   row.source +
          //   '&approvalId=' +
          //   row.approvalId +
          //   '&accurateConditions=' +
          //   row.accurateConditions +
          //   '&businessType=' +
          //   row.businessType +
          //   '&standbyFuzzyConditions=' +
          //   row.standbyFuzzyConditions + '&portal=' + 1,
          //   "_self"
          // );
        }
      })

      // history.pushState(null, '', '/' + '#/Approvainfo?businessId=' + row.businessId +
      // '&sId=' + row.sId + '&source=' + row.source + '&approvalId=' + row.approvalId + '&accurateConditions=' +
      // row.accurateConditions + '&businessType=' + row.businessType)

      // history.pushState(null, '', '/' + '#/Approvainfo?businessId=' + row.businessId +
      // '&sId=' + row.sId + '&source=' + row.source + '&approvalId=' + row.approvalId + '&accurateConditions=' +
      // row.accurateConditions + '&businessType=' + row.businessType)

      // if (row.sId === 'SP0038') { // 跳过节点审批
      //   var projectName = row.fuzzyConditions.substring(0, row.fuzzyConditions.indexOf('#'))
      //   var projectId = row.fuzzyConditions.substring(projectName.length + 1, row.fuzzyConditions.length)
      //   history.pushState(null, '', '/bid#/approve/jumpNodeDetailed?sId=' + row.sId + '&source=' + row.source + '&approvalId=' + row.approvalId + '&accurateConditions=' + row.accurateConditions + '&bidId=' + row.standbyAccurateConditions +
      //   '&initiatorName=' + row.initiatorName + '&projectName=' + projectName + '&projectId=' + projectId + '&standbyFuzzyConditions=' + row.standbyFuzzyConditions)
      // } else {
      //   history.pushState(null, '', '/' + '#/Approvainfo?businessId=' + row.businessId +
      // '&sId=' + row.sId + '&source=' + row.source + '&approvalId=' + row.approvalId + '&accurateConditions=' +
      // row.accurateConditions + '&businessType=' + row.businessType)
      // }
    },
    headClass () {
      // 表头样式设置
      return 'background:#f5f6fa;'
    }
  }
}
</script>

<style lang="scss" scoped>
.basemaintain {
  padding: 5px 20px;
  box-sizing: border-box;
  ::v-deep.el-badge__content.is-fixed {
    top: -6px;
    right: 24px;
  }
  ::v-deep.el-table .warning-row {
    background: #ffffff;
  }
  ::v-deep.el-table .success-row {
    background: #fcfcfd;
  }
  ::v-deep.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #e4e7ed;
  }
  ::v-deep .el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
